module.exports = __webpack_public_path__ + "static/img/20211012_1.3c7f8fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2021/20211012_1.png
// module id = 8r4w
// module chunks = 0